/**
 * Creates Test Details Info Table
 *
 * @param {Object} comprehensiveData - Complete jobcard data
 * @param {Object} reportConfig - Report configuration
 * @returns {Array} Array containing the test details info table
 */

import { AlignmentType, Paragraph, TableRow, PageBreak } from "docx";
import {
  createHeaderCell,
  createCenteredDataCell,
  createCaptionParagraph,
  createDataTable,
  createTableHeadingParagraph,
} from "./Report_Functions/docxHelpers";

export const createTestDetailsInfoTable = (comprehensiveData, reportConfig) => {
  //Caption text:
  const testDetailsCaptionText = `Note: All samples tested as per customer test profile and samples handed over to the representative of customer. `;

  //APpendix-A caption:
  const appendixACaptionText = `Reports and Photos are in Appendix A`;

  // Access current test data using the currentTest_* prefix fields
  // These fields are generated by prepareReportData() in TS1ReportDocument.js
  const testDetailsData = [
    {
      slNo: 1,
      eutNo: comprehensiveData?.currentTest_eutSerialNo || "",
      test: comprehensiveData?.currentTest_testName || "",
      chamberMakeEquipment: reportConfig?.chambers[0]?.chamberMake || "",
      testProfile: comprehensiveData?.currentTest_standard || "",
      observation: comprehensiveData?.currentTest_remarks || "",
    },
  ];

  // Create header row using helper functions
  const headerRow = new TableRow({
    tableHeader: true,
    children: [
      createHeaderCell("SL No.", { width: 8 }),
      createHeaderCell("EUT\nSerial No.", { width: 12 }),
      createHeaderCell("Test", { width: 20 }),
      createHeaderCell("Chamber/Make/\nEquipment SL no.", { width: 25 }),
      createHeaderCell("Test Profile", { width: 15 }),
      createHeaderCell("Observation", { width: 20 }),
    ],
  });

  // Create data rows using helper functions
  const dataRows = testDetailsData.map(
    (row) =>
      new TableRow({
        children: [
          createCenteredDataCell(String(row.slNo), { width: 8 }),
          // createCenteredDataCell(row.eutNo, { width: 12 }),
          createCenteredDataCell("Refer Table - 1", { width: 12 }),
          createCenteredDataCell(row.test, { width: 20 }),
          createCenteredDataCell(row.chamberMakeEquipment, { width: 25 }),
          createCenteredDataCell(row.testProfile, { width: 15 }),
          createCenteredDataCell(row.observation, { width: 20 }),
        ],
      })
  );

  return [
    // Section heading
    createTableHeadingParagraph(
      "Table-2: EUT/DUT numbers and respective details for tests conducted"
    ),

    // Test details table
    createDataTable([headerRow, ...dataRows]),

    // Caption below the table
    createCaptionParagraph(testDetailsCaptionText),

    // Appendix-A Caption
    createCaptionParagraph(appendixACaptionText, {
      alignment: AlignmentType.LEFT,
    }),

    // Page break after the table
    new Paragraph({
      children: [new PageBreak()],
    }),
  ];
};
